/* eslint-disable */
import { MoveRight, Plus } from 'lucide-react'
import { useEffect, useState } from 'react'
import { Button } from '../../Components/ui/button'
import { Info, KeyboardArrowDown, KeyboardArrowUp, Refresh } from '@mui/icons-material'
import { useRecoilRefresher_UNSTABLE, useRecoilValueLoadable } from 'recoil'
import { Card, CardContent, CardHeader, CardTitle } from '../..//Components/ui/card'
import env from '../../env/env'
import { toCurrency } from '../../utils/CurrencyUtil'
import { Link, useLocation } from 'react-router-dom'
import { MFBasketOrders } from '../../store/MFBasketsStore'
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../../Components/ui/tabs2'
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../../Components/ui/tooltip'
import { Popover, PopoverContent, PopoverTrigger } from '../../Components/ui/popover'
import { capitalizeWords } from '../../utils/Util'
import MFOrdersSkeleton from '../../Components/SkeletonLoaders/MFOrdersSkeleton'
import SIPsEmpty from '../../Components/EmptyState/SIPsEmpty'
import { InProgressOrders } from '../../store/HomePageStore'
import ApiErrorState from '../../Components/Errors/ApiErrorState'
import { AnimatedDisclosure } from '../../Components/ui/animated-disclosure'
import basketRowIcon from '../../assets/SVGS/fabits-basket-row-icon.svg'

const MFBasketsOrders = ({ showFailedOrders }) => {
  const location = useLocation()
  const orders = useRecoilValueLoadable(MFBasketOrders)
  const inProgressOrders = useRecoilValueLoadable(InProgressOrders)
  const [groupedOrders, setGroupedOrders] = useState({})
  const [completedBasketOrders, setCompletedBasketOrders] = useState({})

  const [inProgressBasketOrders, setInProgressBasketOrders] = useState({})

  const [validInProgressBasketOrders, setValidInProgressBasketOrders] = useState({})

  const [failedBasketOrders, setFailedBasketOrders] = useState({})
  const [expandedIndex, setExpandedIndex] = useState(null)
  const [activeIndex, setActiveIndex] = useState(null)
  const refreshOrder = useRecoilRefresher_UNSTABLE(MFBasketOrders)
  useEffect(() => {
    refreshOrder()
  }, [])

  const getOrderTime = (dateString) => {
    if (!dateString) return 0

    const normalizedDate = String(dateString).trim().replace('T', ' ')
    const [datePart, timePart = ''] = normalizedDate.split(/\s+/)
    const dateParts = datePart.split(datePart.includes('/') ? '/' : '-').map(Number)

    if (dateParts.length === 3 && dateParts.every((part) => !Number.isNaN(part))) {
      const [first, second, third] = dateParts
      const [year, month, day] =
        String(first).length === 4 ? [first, second, third] : [third, second, first]
      const [hours = 0, minutes = 0, seconds = 0] = timePart.split(':').map(Number)

      return new Date(year, month - 1, day, hours || 0, minutes || 0, seconds || 0).getTime()
    }

    const parsedDate = Date.parse(dateString)
    return Number.isNaN(parsedDate) ? 0 : parsedDate
  }

  const getLatestBasketOrderTime = (basketOrders = {}) =>
    Math.max(
      0,
      ...Object.entries(basketOrders).flatMap(([date, orders = []]) =>
        orders.map((order) => getOrderTime(order?.createdDate || date)),
      ),
    )

  const sortGroups = (groupedOrders = {}) =>
    Object.entries(groupedOrders).sort(
      ([, basketOrdersA], [, basketOrdersB]) =>
        getLatestBasketOrderTime(basketOrdersB) - getLatestBasketOrderTime(basketOrdersA),
    )

  const groupByBasketIdAndDate = (orders) =>
    orders?.reduce((acc, { customerBasketInvestmentId, basketStatus, createdDate, ...order }) => {
      if (basketStatus?.toLowerCase() !== 'completed') return acc

      if (!acc[customerBasketInvestmentId]) {
        acc[customerBasketInvestmentId] = {}
      }

      if (!acc[customerBasketInvestmentId][createdDate]) {
        acc[customerBasketInvestmentId][createdDate] = []
      }

      acc[customerBasketInvestmentId][createdDate].push({
        customerBasketInvestmentId,
        basketStatus,
        createdDate,
        ...order,
      })

      return acc
    }, {})

  const groupByBasketIdAndDateInProgress = (orders) =>
    orders?.reduce((acc, { customerBasketInvestmentId, basketStatus, createdDate, ...order }) => {
      if (
        basketStatus.toLowerCase() === 'failed' ||
        order.currentStatus.toLowerCase() === 'failed' ||
        basketStatus?.toLowerCase() === 'completed' ||
        order.currentStatus?.toLowerCase() === 'completed'
      )
        return acc

      if (!acc[customerBasketInvestmentId]) {
        acc[customerBasketInvestmentId] = {}
      }

      if (!acc[customerBasketInvestmentId][createdDate]) {
        acc[customerBasketInvestmentId][createdDate] = []
      }

      acc[customerBasketInvestmentId][createdDate].push({
        customerBasketInvestmentId,
        basketStatus,
        createdDate,
        ...order,
      })

      return acc
    }, {})

  const groupByBasketIdAndDateFailed = (orders) =>
    orders?.reduce((acc, { customerBasketInvestmentId, basketStatus, createdDate, ...order }) => {
      if (basketStatus.toLowerCase() !== 'failed' || order.currentStatus.toLowerCase() !== 'failed')
        return acc

      if (!acc[customerBasketInvestmentId]) {
        acc[customerBasketInvestmentId] = {}
      }

      if (!acc[customerBasketInvestmentId][createdDate]) {
        acc[customerBasketInvestmentId][createdDate] = []
      }

      acc[customerBasketInvestmentId][createdDate].push({
        customerBasketInvestmentId,
        basketStatus,
        createdDate,
        ...order,
      })

      return acc
    }, {})

  // const groupByBasketIdInProgress = (orders) =>
  //   orders?.reduce((acc, { customerBasketInvestmentId, basketStatus, ...order }) => {
  //     if (
  //       basketStatus.toLowerCase() === 'payment processed successfully' ||
  //       order.currentStatus.toLowerCase() === 'order placed successfully'
  //     ) {
  //       if (!acc[customerBasketInvestmentId]) {
  //         acc[customerBasketInvestmentId] = []
  //       }
  //       acc[customerBasketInvestmentId].push({ basketStatus, ...order })
  //     }
  //     return acc
  //   }, {})

  const groupByBasketIdValidInProgress = (orders) =>
    orders?.reduce((acc, { customerBasketInvestmentId, basketStatus, ...order }) => {
      if (!customerBasketInvestmentId) return acc

      if (!acc[customerBasketInvestmentId]) {
        acc[customerBasketInvestmentId] = []
      }
      acc[customerBasketInvestmentId].push({ basketStatus, ...order })

      return acc
    }, {})

  // const groupByBasketIdFailed = (orders) =>
  //   orders?.reduce((acc, { customerBasketInvestmentId, basketStatus, ...order }) => {
  //     if (basketStatus === 'FAILED') {
  //       if (!acc[customerBasketInvestmentId]) {
  //         acc[customerBasketInvestmentId] = []
  //       }
  //       acc[customerBasketInvestmentId].push({ basketStatus, ...order })
  //     }
  //     return acc
  //   }, {})

  useEffect(() => {
    if (orders.state === 'hasValue' && orders?.contents?.orders?.length > 0) {
      setCompletedBasketOrders(groupByBasketIdAndDate(orders.contents.orders))
      setInProgressBasketOrders(groupByBasketIdAndDateInProgress(orders.contents.orders))
      setValidInProgressBasketOrders(
        groupByBasketIdValidInProgress(inProgressOrders?.contents?.data),
      )
      setFailedBasketOrders(groupByBasketIdAndDateFailed(orders.contents.orders))
    } else if (orders.state === 'hasError') {
      console.error('Error fetching orders:', orders.contents)
    }
  }, [orders, showFailedOrders])

  const hasBasketOrders =
    orders?.contents?.status === 'SUCCESS' && orders?.contents?.orders?.length > 0
  const orderTabsContentClass = hasBasketOrders ? 'h-full pb-28 pt-3 lg:px-4 lg:pb-2' : 'hidden'

  // const getTotalUnits = (basketOrders) => {
  //   return basketOrders.reduce((acc, order) => {
  //     return acc + Number(order.allotedUnits ? order.allotedUnits : 0)
  //   }, 0)
  // }

  // const getTotalAmount = (basketOrders) => {
  //   return basketOrders.reduce((acc, order) => {
  //     return acc + Number(order.allotedAmt || order.amount ? order.allotedAmt || order.amount : 0)
  //   }, 0)
  // }

  const getTotalAmountNew = (basketOrders) => {
    return Object.entries(basketOrders).reduce((acc, [date, orders]) => {
      return (
        acc +
        orders.reduce((acc, order) => {
          return (
            acc + Number(order.allotedAmt || order.amount ? order.allotedAmt || order.amount : 0)
          )
        }, 0)
      )
    }, 0)
  }

  const getTotalUnitsNew = (basketOrders) => {
    return Object.entries(basketOrders).reduce((acc, [date, orders]) => {
      return (
        acc +
        orders.reduce((acc, order) => {
          return acc + Number(order.allotedUnits ? order.allotedUnits : 0)
        }, 0)
      )
    }, 0)
  }

  const getStatus = (currentStatus) => {
    const statusMapping = {
      allotment: 'Allotted',
      partial: 'Partial',
      failed: 'Failed',
      processed: 'In Progress',
      placed: 'In Progress',
      redemption: 'Redemption Done',
    }

    // Convert currentStatus to lowercase for case-insensitive matching
    const lowerCaseStatus = currentStatus?.toLowerCase()

    // Iterate over the keys in statusMapping
    for (const keyword in statusMapping) {
      if (lowerCaseStatus?.includes(keyword)) {
        return statusMapping[keyword]
      }
    }

    // Default return value if no keywords are matched
    return 'Unknown Status'
  }

  const getDateMonthYear = (dateString) => {
    if (!dateString) return null // Handle null/undefined cases

    // Determine the correct delimiter
    const delimiter = dateString.includes('/') ? '/' : '-'

    return {
      date: dateString.split(delimiter)[0],
      month: dateString.split(delimiter)[1],
      year: dateString.split(delimiter)[2],
    }
  }

  switch (orders.state) {
    case 'loading':
      return <MFOrdersSkeleton />
    case 'hasValue':
      return (
        <>
          <Tabs
            defaultValue={location.state?.tab || 'completed'}
            className='max-w-[1128px] mx-auto mt-6'
          >
            <div className='flex items-center justify-center px-4 lg:px-0'>
              <TabsList className='grid h-11 w-full max-w-[420px] grid-cols-3 rounded-full md:w-auto'>
                <TabsTrigger
                  value='completed'
                  className='h-9 w-full min-w-0 px-0.5 text-[9px] leading-3 sm:px-1.5 sm:text-xs md:px-4 md:text-sm'
                >
                  Completed ({Object.keys(completedBasketOrders).length})
                </TabsTrigger>
                <TabsTrigger
                  value='in-progress'
                  className='h-9 w-full min-w-0 px-0.5 text-[9px] leading-3 sm:px-1.5 sm:text-xs md:px-4 md:text-sm'
                >
                  {`In-Progress (${
                    ((inProgressBasketOrders && Object.keys(inProgressBasketOrders).length) || 0) +
                    ((validInProgressBasketOrders &&
                      Object.keys(validInProgressBasketOrders).length) ||
                      0)
                  })`}
                </TabsTrigger>
                <TabsTrigger
                  value='failed'
                  className='h-9 w-full min-w-0 px-0.5 text-[9px] leading-3 sm:px-1.5 sm:text-xs md:px-4 md:text-sm'
                >
                  Failed ({Object.keys(failedBasketOrders).length})
                </TabsTrigger>
              </TabsList>
            </div>

            <TabsContent value='completed' className={orderTabsContentClass}>
              {/* MF Orders list */}

              {hasBasketOrders && (
                <>
                  <div className='lg:mx-auto overflow-hidden fabits-compact-card-stack'>
                    {Object.keys(completedBasketOrders).length > 0 ? (
                      sortGroups(completedBasketOrders).map(([key, basketOrders], index) => {
                        const groupAndSortByDate = (basketOrders) => {
                          return Object.entries(basketOrders).reduce((acc, [date, orders]) => {
                            const dateOnly = date.split(' ')[0]

                            if (!acc[dateOnly]) {
                              acc[dateOnly] = []
                            }
                            acc[dateOnly].push(...orders)
                            return acc
                          }, {})
                        }

                        const sortByDateDesc = (data) =>
                          Object.keys(data)
                            .sort((a, b) => getOrderTime(b) - getOrderTime(a))
                            .reduce((acc, key) => {
                              acc[key] = [...data[key]].sort(
                                (a, b) =>
                                  getOrderTime(b?.createdDate || key) -
                                  getOrderTime(a?.createdDate || key),
                              )
                              return acc
                            }, {})

                        const sortedOrders = sortByDateDesc(groupAndSortByDate(basketOrders))

                        const [date, orders] = Object.entries(sortedOrders)[0]

                        return (
                          <div
                            key={key}
                            className='cursor-pointer w-full border-b border-black-100 last:border-b-0'
                          >
                            <div className='fabits-compact-card-heading py-2 text-sm font-medium text-black-400 leading-5 px-4 lg:px-0'>
                              <div
                                className='flex justify-between items-center w-full'
                                onClick={() => {
                                  setExpandedIndex((prev) => (prev === index ? null : index))
                                }}
                              >
                                <div className='w-full md:w-auto'>
                                  <div className='flex md:justify-between items-start md:items-center gap-x-2'>
                                    <img
                                      src={basketRowIcon}
                                      className='fabits-basket-row-icon'
                                      alt=''
                                      aria-hidden='true'
                                    />
                                    <div className='w-full'>
                                      <div className='flex justify-between gap-x-4 items-center'>
                                        <p className='font-semibold text-gray-900  md:max-w-full text-wrap leading-6'>
                                          {orders[0]?.customerBasketName}
                                        </p>

                                        {orders[0]?.buySell && (
                                          <p
                                            className={`hidden md:block text-sm leading-4 px-3 py-1 rounded-full ${
                                              orders[0]?.buySell === 'P'
                                                ? 'bg-secondary-50 text-secondary-600'
                                                : 'bg-error-50 text-error-600'
                                            }`}
                                          >
                                            {orders[0]?.buySell === 'P' ? 'Buy' : 'Sell'}
                                          </p>
                                        )}

                                        <span className='flex-shrink-0 text-black-200 md:hidden'>
                                          {expandedIndex === index ? (
                                            <KeyboardArrowUp
                                              className='flex-shrink-0 text-black-200'
                                              sx={{ fontSize: '24px' }}
                                            />
                                          ) : (
                                            <KeyboardArrowDown
                                              className='flex-shrink-0 text-black-200'
                                              sx={{ fontSize: '24px' }}
                                            />
                                          )}
                                        </span>
                                      </div>

                                      <div className='flex justify-between md:justify-normal gap-x-5'>
                                        <p
                                          className={`text-sm font-medium ${
                                            orders[0]?.basketStatus.toLowerCase() === 'completed'
                                              ? 'text-secondary-600'
                                              : orders[0]?.basketStatus.toLowerCase() ===
                                                'in progress'
                                              ? 'text-warning-600'
                                              : 'text-error-600'
                                          }`}
                                        >
                                          {/* {failedBasketOrders[key]?.length > 0
                                          ? 'Basket needs attention'
                                          : partialOrders?.length === 0 &&
                                            failedBasketOrders[key]?.length === 0
                                          ? 'Allotted'
                                          : partialOrders?.length > 0
                                          ? 'In Progress'
                                          : failedBasketOrders[key]?.length === basketOrders?.length
                                          ? 'Failed'
                                          : ''} */}
                                          {capitalizeWords(orders[0]?.basketStatus)}
                                        </p>

                                        {/* <p className='hidden md:block text-sm text-black-400 leading-5 font-medium'>
                                        Basket Order ID : {orders[0]?.customerBasketOrderNo}
                                      </p> */}

                                        {orders[0]?.buySell && (
                                          <p
                                            className={`md:hidden text-sm leading-4 px-3 py-1 rounded-full ${
                                              orders[0]?.buySell === 'P'
                                                ? 'bg-secondary-50 text-secondary-600'
                                                : 'bg-error-50 text-error-600'
                                            }`}
                                          >
                                            {orders[0]?.buySell === 'P' ? 'Buy' : 'Sell'}
                                          </p>
                                        )}
                                      </div>

                                      {orders[0]?.basketStatus.toLowerCase() != 'failed' && (
                                        <div className='flex justify-between mt-1 md:hidden'>
                                          {/* <p className='text-sm text-black-400 leading-5 font-medium'>
                                        Basket Order ID : {orders[0]?.customerBasketOrderNo}
                                      </p> */}

                                          {orders[0]?.basketStatus.toLowerCase() === 'completed' ? (
                                            <p className='text-sm font-medium text-black-400'>
                                              {toCurrency(getTotalUnitsNew(sortedOrders))} Units
                                            </p>
                                          ) : (
                                            <>
                                              <Popover>
                                                <PopoverTrigger
                                                  className='text-black-400'
                                                  onClick={(e) => e.stopPropagation()} // Prevent parent click
                                                >
                                                  In progress{' '}
                                                  <Info
                                                    fontSize='10px'
                                                    className='text-black-100'
                                                  />
                                                </PopoverTrigger>
                                                <PopoverContent className='bg-black-500 text-center'>
                                                  <p className='text-white'>
                                                    Investments could take up to 4 days to reflect
                                                    in your account
                                                  </p>
                                                </PopoverContent>
                                              </Popover>
                                            </>
                                          )}

                                          {orders[0]?.basketStatus.toLowerCase() === 'completed' ? (
                                            <p className='text-sm font-semibold text-black-500'>
                                              ₹ {toCurrency(getTotalAmountNew(sortedOrders))}
                                            </p>
                                          ) : (
                                            <Popover>
                                              <PopoverTrigger
                                                className='text-black-400'
                                                onClick={(e) => e.stopPropagation()} // Prevent parent click
                                              >
                                                In progress{' '}
                                                <Info fontSize='10px' className='text-black-100' />
                                              </PopoverTrigger>
                                              <PopoverContent className='bg-black-500 text-center'>
                                                <p className='text-white'>
                                                  Investments could take up to 4 days to reflect in
                                                  your account
                                                </p>
                                              </PopoverContent>
                                            </Popover>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>

                                <div className='flex items-center gap-x-4'>
                                  {
                                    <div className='hidden md:flex leading-5 flex-shrink-0 text-right'>
                                      {orders[0]?.basketStatus.toLowerCase() === 'completed' ? (
                                        <p className='text-sm font-medium text-black-400'>
                                          {toCurrency(getTotalUnitsNew(sortedOrders))} Units
                                        </p>
                                      ) : (
                                        <>
                                          {' '}
                                          {orders[0]?.basketStatus.toLowerCase() != 'failed' && (
                                            <TooltipProvider delayDuration={0}>
                                              <Tooltip>
                                                <TooltipTrigger className='text-black-400'>
                                                  In progress{' '}
                                                  <Info
                                                    fontSize='10px'
                                                    className='text-black-100'
                                                  />
                                                </TooltipTrigger>
                                                <TooltipContent className='bg-black-500 max-w-[275px] border-0'>
                                                  <p className='text-white'>
                                                    Investments could take up to 4 days to reflect
                                                    in your account
                                                  </p>
                                                  <TooltipArrow />
                                                </TooltipContent>
                                              </Tooltip>
                                            </TooltipProvider>
                                          )}
                                        </>
                                      )}
                                    </div>
                                  }

                                  <div className='hidden md:flex justify-end items-center gap-x-1 min-w-[150px]'>
                                    {orders[0]?.basketStatus.toLowerCase() === 'completed' ? (
                                      <p className='font-semibold leading-6 text-black-500'>
                                        ₹ {toCurrency(getTotalAmountNew(sortedOrders))}
                                      </p>
                                    ) : (
                                      <>
                                        {orders[0]?.basketStatus.toLowerCase() != 'failed' && (
                                          <TooltipProvider delayDuration={0}>
                                            <Tooltip>
                                              <TooltipTrigger className='text-black-400'>
                                                In progress{' '}
                                                <Info fontSize='10px' className='text-black-100' />
                                              </TooltipTrigger>
                                              <TooltipContent className='bg-black-500 max-w-[275px] border-0'>
                                                <p className='text-white'>
                                                  Investments could take up to 4 days to reflect in
                                                  your account
                                                </p>
                                                <TooltipArrow />
                                              </TooltipContent>
                                            </Tooltip>
                                          </TooltipProvider>
                                        )}
                                      </>
                                    )}

                                    {expandedIndex === index ? (
                                      <KeyboardArrowUp
                                        className='flex-shrink-0 text-black-200'
                                        sx={{ fontSize: '24px' }}
                                      />
                                    ) : (
                                      <KeyboardArrowDown
                                        className='flex-shrink-0 text-black-200'
                                        sx={{ fontSize: '24px' }}
                                      />
                                    )}
                                  </div>
                                </div>
                              </div>
                              <AnimatedDisclosure
                                open={expandedIndex === index}
                                className='text-sm md:pl-6 flex-col justify-between items-start mt-4 border-b text-gray-500'
                                contentClassName='pt-4'
                              >
                                {Object.entries(sortedOrders)?.map(([date, orders]) => {
                                  // Check if all orders have the same order number

                                  const allSameOrderDateSame = orders.every(
                                    (order) => order.createdDate.split(' ')[0] === date,
                                  )

                                  return (
                                    <>
                                      {orders.map((order, orderIndex) => {
                                        // Show order number and date only once if all orders have same order number
                                        const shouldShowOrderInfo =
                                          !allSameOrderDateSame ||
                                          (allSameOrderDateSame && orderIndex === 0)

                                        return (
                                          <div
                                            className={`p-4 flex items-center lg:items-start w-full`}
                                            key={date + orderIndex}
                                          >
                                            <div className='flex justify-between w-full'>
                                              <div className='flex justify-between items-center w-full'>
                                                <div className='w-full md:w-auto'>
                                                  {shouldShowOrderInfo && (
                                                    <p className='text-black-400 text-sm mb-1'>
                                                      {date}
                                                    </p>
                                                  )}

                                                  <div className='flex justify-between items-start md:items-center gap-x-2'>
                                                    <img
                                                      src={`${env.MF_LOGOS_URL}/${order?.amcCode}.png`}
                                                      className='h-12 w-12 rounded-[8px] mt-1'
                                                    />
                                                    <div className='w-full md:w-auto'>
                                                      <p className='font-semibold text-gray-900  md:max-w-full text-wrap leading-6'>
                                                        {order?.legalName
                                                          ? order?.legalName
                                                          : order?.schemeName}
                                                      </p>

                                                      <div className='flex justify-between md:justify-normal w-full gap-x-5'>
                                                        <p
                                                          className={`text-sm font-medium ${
                                                            getStatus(order.currentStatus) ===
                                                            'Failed'
                                                              ? 'text-error-600'
                                                              : getStatus(order.currentStatus) ===
                                                                'Allotted'
                                                              ? 'text-secondary-600'
                                                              : getStatus(order.currentStatus) ===
                                                                'Redemption Done'
                                                              ? 'text-secondary-600'
                                                              : 'text-warning-600'
                                                          }`}
                                                        >
                                                          {getStatus(order.currentStatus)}
                                                        </p>

                                                        <p className='hidden md:block text-sm text-black-400 leading-5 font-medium'>
                                                          Order ID : {order?.orderNumber}
                                                        </p>

                                                        {order?.buySell && (
                                                          <p
                                                            className={`md:hidden text-sm leading-4 px-3 py-1 rounded-full ${
                                                              order?.buySell === 'P'
                                                                ? 'bg-secondary-50 text-secondary-600'
                                                                : 'bg-error-50 text-error-600'
                                                            }`}
                                                          >
                                                            {order?.buySell === 'P'
                                                              ? 'Buy'
                                                              : 'Sell'}
                                                          </p>
                                                        )}
                                                      </div>

                                                      <div className='flex md:hidden justify-between items-center gap-x-2'>
                                                        {order.allotedUnits && (
                                                          <p className='text-sm font-medium text-black-400'>
                                                            {order.allotedUnits
                                                              ? toCurrency(order.allotedUnits)
                                                              : null}{' '}
                                                            Units
                                                          </p>
                                                        )}

                                                        {order.allotedAmt && (
                                                          <p className='font-semibold leading-6 text-black-500'>
                                                            ₹{' '}
                                                            {order.allotedAmt
                                                              ? toCurrency(order.allotedAmt)
                                                              : null}
                                                          </p>
                                                        )}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className='flex items-center gap-x-2'>
                                                  <div className='hidden md:flex justify-center leading-5 flex-shrink-0 text-right min-w-[100px] pr-2'>
                                                    {order.allotedUnits && (
                                                      <p className='text-sm font-medium text-black-400'>
                                                        {order.allotedUnits
                                                          ? toCurrency(order.allotedUnits)
                                                          : null}{' '}
                                                        Units
                                                      </p>
                                                    )}
                                                  </div>

                                                  <div className='hidden md:flex justify-end items-center gap-x-1 min-w-[150px] pr-4'>
                                                    {order.allotedAmt && (
                                                      <p className='font-semibold leading-6 text-black-500'>
                                                        ₹{' '}
                                                        {order.allotedAmt
                                                          ? toCurrency(order.allotedAmt)
                                                          : null}
                                                      </p>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )
                                      })}
                                    </>
                                  )
                                })}
                              </AnimatedDisclosure>
                            </div>
                          </div>
                        )
                      })
                    ) : (
                      <SIPsEmpty
                        title='You haven’t started any new orders yet.'
                        description='It seems like you haven’t started any new orders yet. Once you place an order, it will appear here as it progresses through the system.'
                        mainText='You haven’t started any new orders yet.'
                        page='/dashboard/mutual-funds/orders'
                        showButton={false}
                        variant='completed'
                      />
                    )}
                  </div>
                </>
              )}
            </TabsContent>

            <TabsContent value='in-progress' className={orderTabsContentClass}>
              {/* MF Orders list */}

              {hasBasketOrders && (
                <>
                  <div className='lg:mx-auto overflow-hidden fabits-compact-card-stack'>
                    {Object.keys(inProgressBasketOrders).length > 0 ? (
                      sortGroups(inProgressBasketOrders).map(([key, basketOrders], index) => {
                        const groupAndSortByDate = (basketOrders) => {
                          return Object.entries(basketOrders).reduce((acc, [date, orders]) => {
                            const dateOnly = date.split(' ')[0]

                            if (!acc[dateOnly]) {
                              acc[dateOnly] = []
                            }
                            acc[dateOnly].push(...orders)
                            return acc
                          }, {})
                        }

                        const sortByDateDesc = (data) =>
                          Object.keys(data)
                            .sort((a, b) => getOrderTime(b) - getOrderTime(a))
                            .reduce((acc, key) => {
                              acc[key] = [...data[key]].sort(
                                (a, b) =>
                                  getOrderTime(b?.createdDate || key) -
                                  getOrderTime(a?.createdDate || key),
                              )
                              return acc
                            }, {})

                        const sortedOrders = sortByDateDesc(groupAndSortByDate(basketOrders))

                        const [date, orders] = Object.entries(sortedOrders)[0]

                        return (
                          <div
                            key={key}
                            className='cursor-pointer w-full border-b border-black-100 last:border-b-0'
                          >
                            <div className='fabits-compact-card-heading py-2 text-sm font-medium text-black-400 leading-5 px-4 lg:px-0'>
                              <div
                                className='flex justify-between items-center w-full'
                                onClick={() => {
                                  setExpandedIndex((prev) => (prev === index ? null : index))
                                }}
                              >
                                <div className='w-full md:w-auto'>
                                  <div className='flex md:justify-between items-start md:items-center gap-x-2'>
                                    <img
                                      src={basketRowIcon}
                                      className='fabits-basket-row-icon'
                                      alt=''
                                      aria-hidden='true'
                                    />
                                    <div className='w-full'>
                                      <div className='flex justify-between gap-x-4 items-center'>
                                        <p className='font-semibold text-gray-900  md:max-w-full text-wrap leading-6'>
                                          {orders[0]?.customerBasketName}
                                        </p>

                                        {orders[0]?.buySell && (
                                          <p
                                            className={`hidden md:block text-sm leading-4 px-3 py-1 rounded-full ${
                                              orders[0]?.buySell === 'P'
                                                ? 'bg-secondary-50 text-secondary-600'
                                                : 'bg-error-50 text-error-600'
                                            }`}
                                          >
                                            {orders[0]?.buySell === 'P' ? 'Buy' : 'Sell'}
                                          </p>
                                        )}

                                        <span className='flex-shrink-0 text-black-200 md:hidden'>
                                          {expandedIndex === index ? (
                                            <KeyboardArrowUp
                                              className='flex-shrink-0 text-black-200'
                                              sx={{ fontSize: '24px' }}
                                            />
                                          ) : (
                                            <KeyboardArrowDown
                                              className='flex-shrink-0 text-black-200'
                                              sx={{ fontSize: '24px' }}
                                            />
                                          )}
                                        </span>
                                      </div>

                                      <div className='flex justify-between md:justify-normal gap-x-5'>
                                        <p
                                          className={`text-sm font-medium ${
                                            orders[0]?.basketStatus.toLowerCase() === 'completed'
                                              ? 'text-secondary-600'
                                              : orders[0]?.basketStatus.toLowerCase() ===
                                                'in progress'
                                              ? 'text-warning-600'
                                              : 'text-error-600'
                                          }`}
                                        >
                                          {/* {failedBasketOrders[key]?.length > 0
                                          ? 'Basket needs attention'
                                          : partialOrders?.length === 0 &&
                                            failedBasketOrders[key]?.length === 0
                                          ? 'Allotted'
                                          : partialOrders?.length > 0
                                          ? 'In Progress'
                                          : failedBasketOrders[key]?.length === basketOrders?.length
                                          ? 'Failed'
                                          : ''} */}
                                          {capitalizeWords(orders[0]?.basketStatus)}
                                        </p>

                                        {/* <p className='hidden md:block text-sm text-black-400 leading-5 font-medium'>
                                        Basket Order ID : {orders[0]?.customerBasketOrderNo}
                                      </p> */}

                                        {orders[0]?.buySell && (
                                          <p
                                            className={`md:hidden text-sm leading-4 px-3 py-1 rounded-full ${
                                              orders[0]?.buySell === 'P'
                                                ? 'bg-secondary-50 text-secondary-600'
                                                : 'bg-error-50 text-error-600'
                                            }`}
                                          >
                                            {orders[0]?.buySell === 'P' ? 'Buy' : 'Sell'}
                                          </p>
                                        )}
                                      </div>

                                      {orders[0]?.basketStatus.toLowerCase() != 'failed' && (
                                        <div className='flex justify-between mt-1 md:hidden'>
                                          {/* <p className='text-sm text-black-400 leading-5 font-medium'>
                                        Basket Order ID : {orders[0]?.customerBasketOrderNo}
                                      </p> */}

                                          {orders[0]?.basketStatus.toLowerCase() === 'completed' ? (
                                            <p className='text-sm font-medium text-black-400'>
                                              {toCurrency(getTotalUnitsNew(sortedOrders))} Units
                                            </p>
                                          ) : (
                                            <>
                                              <Popover>
                                                <PopoverTrigger
                                                  className='text-black-400'
                                                  onClick={(e) => e.stopPropagation()} // Prevent parent click
                                                >
                                                  In progress{' '}
                                                  <Info
                                                    fontSize='10px'
                                                    className='text-black-100'
                                                  />
                                                </PopoverTrigger>
                                                <PopoverContent className='bg-black-500 text-center'>
                                                  <p className='text-white'>
                                                    Investments could take up to 4 days to reflect
                                                    in your account
                                                  </p>
                                                </PopoverContent>
                                              </Popover>
                                            </>
                                          )}

                                          {orders[0]?.basketStatus.toLowerCase() === 'completed' ? (
                                            <p className='text-sm font-semibold text-black-500'>
                                              ₹ {toCurrency(getTotalAmountNew(sortedOrders))}
                                            </p>
                                          ) : (
                                            <Popover>
                                              <PopoverTrigger
                                                className='text-black-400'
                                                onClick={(e) => e.stopPropagation()} // Prevent parent click
                                              >
                                                In progress{' '}
                                                <Info fontSize='10px' className='text-black-100' />
                                              </PopoverTrigger>
                                              <PopoverContent className='bg-black-500 text-center'>
                                                <p className='text-white'>
                                                  Investments could take up to 4 days to reflect in
                                                  your account
                                                </p>
                                              </PopoverContent>
                                            </Popover>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>

                                <div className='flex items-center gap-x-4'>
                                  {
                                    <div className='hidden md:flex leading-5 flex-shrink-0 text-right'>
                                      {orders[0]?.basketStatus.toLowerCase() === 'completed' ? (
                                        <p className='text-sm font-medium text-black-400'>
                                          {toCurrency(getTotalUnitsNew(sortedOrders))} Units
                                        </p>
                                      ) : (
                                        <>
                                          {' '}
                                          {orders[0]?.basketStatus.toLowerCase() != 'failed' && (
                                            <TooltipProvider delayDuration={0}>
                                              <Tooltip>
                                                <TooltipTrigger className='text-black-400'>
                                                  In progress{' '}
                                                  <Info
                                                    fontSize='10px'
                                                    className='text-black-100'
                                                  />
                                                </TooltipTrigger>
                                                <TooltipContent className='bg-black-500 max-w-[275px] border-0'>
                                                  <p className='text-white'>
                                                    Investments could take up to 4 days to reflect
                                                    in your account
                                                  </p>
                                                  <TooltipArrow />
                                                </TooltipContent>
                                              </Tooltip>
                                            </TooltipProvider>
                                          )}
                                        </>
                                      )}
                                    </div>
                                  }

                                  <div className='hidden md:flex justify-end items-center gap-x-1 min-w-[150px]'>
                                    {orders[0]?.basketStatus.toLowerCase() === 'completed' ? (
                                      <p className='font-semibold leading-6 text-black-500'>
                                        ₹ {toCurrency(getTotalAmountNew(sortedOrders))}
                                      </p>
                                    ) : (
                                      <>
                                        {orders[0]?.basketStatus.toLowerCase() != 'failed' && (
                                          <TooltipProvider delayDuration={0}>
                                            <Tooltip>
                                              <TooltipTrigger className='text-black-400'>
                                                In progress{' '}
                                                <Info fontSize='10px' className='text-black-100' />
                                              </TooltipTrigger>
                                              <TooltipContent className='bg-black-500 max-w-[275px] border-0'>
                                                <p className='text-white'>
                                                  Investments could take up to 4 days to reflect in
                                                  your account
                                                </p>
                                                <TooltipArrow />
                                              </TooltipContent>
                                            </Tooltip>
                                          </TooltipProvider>
                                        )}
                                      </>
                                    )}

                                    {expandedIndex === index ? (
                                      <KeyboardArrowUp
                                        className='flex-shrink-0 text-black-200'
                                        sx={{ fontSize: '24px' }}
                                      />
                                    ) : (
                                      <KeyboardArrowDown
                                        className='flex-shrink-0 text-black-200'
                                        sx={{ fontSize: '24px' }}
                                      />
                                    )}
                                  </div>
                                </div>
                              </div>
                              <AnimatedDisclosure
                                open={expandedIndex === index}
                                className='text-sm md:pl-6 flex-col justify-between items-start mt-4 border-b text-gray-500'
                                contentClassName='pt-4'
                              >
                                {Object.entries(sortedOrders)?.map(([date, orders]) => {
                                  // Check if all orders have the same order number

                                  const allSameOrderDateSame = orders.every(
                                    (order) => order.createdDate.split(' ')[0] === date,
                                  )

                                  return (
                                    <>
                                      {orders.map((order, orderIndex) => {
                                        // Show order number and date only once if all orders have same order number
                                        const shouldShowOrderInfo =
                                          !allSameOrderDateSame ||
                                          (allSameOrderDateSame && orderIndex === 0)

                                        return (
                                          <div
                                            className={`p-4 flex items-center lg:items-start w-full`}
                                            key={date + orderIndex}
                                          >
                                            <div className='flex justify-between w-full'>
                                              <div className='flex justify-between items-center w-full'>
                                                <div className='w-full md:w-auto'>
                                                  {shouldShowOrderInfo && (
                                                    <p className='text-black-400 text-sm mb-1'>
                                                      {date}
                                                    </p>
                                                  )}

                                                  <div className='flex justify-between items-start md:items-center gap-x-2'>
                                                    <img
                                                      src={`${env.MF_LOGOS_URL}/${order?.amcCode}.png`}
                                                      className='h-12 w-12 rounded-[8px] mt-1'
                                                    />
                                                    <div className='w-full md:w-auto'>
                                                      <p className='font-semibold text-gray-900  md:max-w-full text-wrap leading-6'>
                                                        {order?.legalName
                                                          ? order?.legalName
                                                          : order?.schemeName}
                                                      </p>

                                                      <div className='flex justify-between md:justify-normal w-full gap-x-5'>
                                                        <p
                                                          className={`text-sm font-medium ${
                                                            getStatus(order.currentStatus) ===
                                                            'Failed'
                                                              ? 'text-error-600'
                                                              : getStatus(order.currentStatus) ===
                                                                'Allotted'
                                                              ? 'text-secondary-600'
                                                              : getStatus(order.currentStatus) ===
                                                                'Redemption Done'
                                                              ? 'text-secondary-600'
                                                              : 'text-warning-600'
                                                          }`}
                                                        >
                                                          {getStatus(order.currentStatus)}
                                                        </p>

                                                        <p className='hidden md:block text-sm text-black-400 leading-5 font-medium'>
                                                          Order ID : {order?.orderNumber}
                                                        </p>

                                                        {order?.buySell && (
                                                          <p
                                                            className={`md:hidden text-sm leading-4 px-3 py-1 rounded-full ${
                                                              order?.buySell === 'P'
                                                                ? 'bg-secondary-50 text-secondary-600'
                                                                : 'bg-error-50 text-error-600'
                                                            }`}
                                                          >
                                                            {order?.buySell === 'P'
                                                              ? 'Buy'
                                                              : 'Sell'}
                                                          </p>
                                                        )}
                                                      </div>

                                                      <div className='flex md:hidden justify-between items-center gap-x-2'>
                                                        {order.allotedUnits && (
                                                          <p className='text-sm font-medium text-black-400'>
                                                            {order.allotedUnits
                                                              ? toCurrency(order.allotedUnits)
                                                              : null}{' '}
                                                            Units
                                                          </p>
                                                        )}

                                                        {order.allotedAmt && (
                                                          <p className='font-semibold leading-6 text-black-500'>
                                                            ₹{' '}
                                                            {order.allotedAmt
                                                              ? toCurrency(order.allotedAmt)
                                                              : null}
                                                          </p>
                                                        )}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className='flex items-center gap-x-2'>
                                                  <div className='hidden md:flex justify-center leading-5 flex-shrink-0 text-right min-w-[100px] pr-2'>
                                                    {order.allotedUnits && (
                                                      <p className='text-sm font-medium text-black-400'>
                                                        {order.allotedUnits
                                                          ? toCurrency(order.allotedUnits)
                                                          : null}{' '}
                                                        Units
                                                      </p>
                                                    )}
                                                  </div>

                                                  <div className='hidden md:flex justify-end items-center gap-x-1 min-w-[150px] pr-4'>
                                                    {order.allotedAmt && (
                                                      <p className='font-semibold leading-6 text-black-500'>
                                                        ₹{' '}
                                                        {order.allotedAmt
                                                          ? toCurrency(order.allotedAmt)
                                                          : null}
                                                      </p>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )
                                      })}
                                    </>
                                  )
                                })}
                              </AnimatedDisclosure>
                            </div>
                          </div>
                        )
                      })
                    ) : (
                      <SIPsEmpty
                        title='You haven’t started any new orders yet.'
                        description='It seems like you haven’t started any new orders yet. Once you place an order, it will appear here as it progresses through the system.'
                        mainText='You haven’t started any new orders yet.'
                        page='/dashboard/mutual-funds/orders'
                        showButton={false}
                        variant='inProgress'
                      />
                    )}
                  </div>
                </>
              )}
            </TabsContent>

            <TabsContent value='failed' className={orderTabsContentClass}>
              {/* MF Orders list */}

              {hasBasketOrders && (
                <>
                  <div className='lg:mx-auto overflow-hidden fabits-compact-card-stack'>
                    {Object.keys(failedBasketOrders).length > 0 ? (
                      sortGroups(failedBasketOrders).map(([key, basketOrders], index) => {
                        const groupAndSortByDate = (basketOrders) => {
                          return Object.entries(basketOrders).reduce((acc, [date, orders]) => {
                            const dateOnly = date.split(' ')[0]

                            if (!acc[dateOnly]) {
                              acc[dateOnly] = []
                            }
                            acc[dateOnly].push(...orders)
                            return acc
                          }, {})
                        }

                        const sortByDateDesc = (data) =>
                          Object.keys(data)
                            .sort((a, b) => getOrderTime(b) - getOrderTime(a))
                            .reduce((acc, key) => {
                              acc[key] = [...data[key]].sort(
                                (a, b) =>
                                  getOrderTime(b?.createdDate || key) -
                                  getOrderTime(a?.createdDate || key),
                              )
                              return acc
                            }, {})

                        const sortedOrders = sortByDateDesc(groupAndSortByDate(basketOrders))

                        const [date, orders] = Object.entries(sortedOrders)[0]

                        return (
                          <div
                            key={key}
                            className='cursor-pointer w-full border-b border-black-100 last:border-b-0'
                          >
                            <div className='fabits-compact-card-heading py-2 text-sm font-medium text-black-400 leading-5 px-4 lg:px-0'>
                              <div
                                className='flex justify-between items-center w-full'
                                onClick={() => {
                                  setExpandedIndex((prev) => (prev === index ? null : index))
                                }}
                              >
                                <div className='w-full md:w-auto'>
                                  <div className='flex md:justify-between items-start md:items-center gap-x-2'>
                                    <img
                                      src={basketRowIcon}
                                      className='fabits-basket-row-icon'
                                      alt=''
                                      aria-hidden='true'
                                    />
                                    <div className='w-full'>
                                      <div className='flex justify-between gap-x-4 items-center'>
                                        <p className='font-semibold text-gray-900  md:max-w-full text-wrap leading-6'>
                                          {orders[0]?.customerBasketName}
                                        </p>

                                        {orders[0]?.buySell && (
                                          <p
                                            className={`hidden md:block text-sm leading-4 px-3 py-1 rounded-full ${
                                              orders[0]?.buySell === 'P'
                                                ? 'bg-secondary-50 text-secondary-600'
                                                : 'bg-error-50 text-error-600'
                                            }`}
                                          >
                                            {orders[0]?.buySell === 'P' ? 'Buy' : 'Sell'}
                                          </p>
                                        )}

                                        <span className='flex-shrink-0 text-black-200 md:hidden'>
                                          {expandedIndex === index ? (
                                            <KeyboardArrowUp
                                              className='flex-shrink-0 text-black-200'
                                              sx={{ fontSize: '24px' }}
                                            />
                                          ) : (
                                            <KeyboardArrowDown
                                              className='flex-shrink-0 text-black-200'
                                              sx={{ fontSize: '24px' }}
                                            />
                                          )}
                                        </span>
                                      </div>

                                      <div className='flex justify-between md:justify-normal gap-x-5'>
                                        <p
                                          className={`text-sm font-medium ${
                                            orders[0]?.basketStatus.toLowerCase() === 'completed'
                                              ? 'text-secondary-600'
                                              : orders[0]?.basketStatus.toLowerCase() ===
                                                'in progress'
                                              ? 'text-warning-600'
                                              : 'text-error-600'
                                          }`}
                                        >
                                          {/* {failedBasketOrders[key]?.length > 0
                                          ? 'Basket needs attention'
                                          : partialOrders?.length === 0 &&
                                            failedBasketOrders[key]?.length === 0
                                          ? 'Allotted'
                                          : partialOrders?.length > 0
                                          ? 'In Progress'
                                          : failedBasketOrders[key]?.length === basketOrders?.length
                                          ? 'Failed'
                                          : ''} */}
                                          {capitalizeWords(orders[0]?.orderRemarks)}
                                        </p>

                                        {/* <p className='hidden md:block text-sm text-black-400 leading-5 font-medium'>
                                        Basket Order ID : {orders[0]?.customerBasketOrderNo}
                                      </p> */}

                                        {orders[0]?.buySell && (
                                          <p
                                            className={`md:hidden text-sm leading-4 px-3 py-1 rounded-full ${
                                              orders[0]?.buySell === 'P'
                                                ? 'bg-secondary-50 text-secondary-600'
                                                : 'bg-error-50 text-error-600'
                                            }`}
                                          >
                                            {orders[0]?.buySell === 'P' ? 'Buy' : 'Sell'}
                                          </p>
                                        )}
                                      </div>

                                      {orders[0]?.basketStatus.toLowerCase() != 'failed' && (
                                        <div className='flex justify-between mt-1 md:hidden'>
                                          {/* <p className='text-sm text-black-400 leading-5 font-medium'>
                                        Basket Order ID : {orders[0]?.customerBasketOrderNo}
                                      </p> */}

                                          {orders[0]?.basketStatus.toLowerCase() === 'completed' ? (
                                            <p className='text-sm font-medium text-black-400'>
                                              {toCurrency(getTotalUnitsNew(sortedOrders))} Units
                                            </p>
                                          ) : (
                                            <>
                                              <Popover>
                                                <PopoverTrigger
                                                  className='text-black-400'
                                                  onClick={(e) => e.stopPropagation()} // Prevent parent click
                                                >
                                                  In progress{' '}
                                                  <Info
                                                    fontSize='10px'
                                                    className='text-black-100'
                                                  />
                                                </PopoverTrigger>
                                                <PopoverContent className='bg-black-500 text-center'>
                                                  <p className='text-white'>
                                                    Investments could take up to 4 days to reflect
                                                    in your account
                                                  </p>
                                                </PopoverContent>
                                              </Popover>
                                            </>
                                          )}

                                          {orders[0]?.basketStatus.toLowerCase() === 'completed' ? (
                                            <p className='text-sm font-semibold text-black-500'>
                                              ₹ {toCurrency(getTotalAmountNew(sortedOrders))}
                                            </p>
                                          ) : (
                                            <Popover>
                                              <PopoverTrigger
                                                className='text-black-400'
                                                onClick={(e) => e.stopPropagation()} // Prevent parent click
                                              >
                                                In progress{' '}
                                                <Info fontSize='10px' className='text-black-100' />
                                              </PopoverTrigger>
                                              <PopoverContent className='bg-black-500 text-center'>
                                                <p className='text-white'>
                                                  Investments could take up to 4 days to reflect in
                                                  your account
                                                </p>
                                              </PopoverContent>
                                            </Popover>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>

                                <div className='flex items-center gap-x-4'>
                                  {
                                    <div className='hidden md:flex leading-5 flex-shrink-0 text-right'>
                                      {orders[0]?.basketStatus.toLowerCase() === 'completed' ? (
                                        <p className='text-sm font-medium text-black-400'>
                                          {toCurrency(getTotalUnitsNew(sortedOrders))} Units
                                        </p>
                                      ) : (
                                        <>
                                          {' '}
                                          {orders[0]?.basketStatus.toLowerCase() != 'failed' && (
                                            <TooltipProvider delayDuration={0}>
                                              <Tooltip>
                                                <TooltipTrigger className='text-black-400'>
                                                  In progress{' '}
                                                  <Info
                                                    fontSize='10px'
                                                    className='text-black-100'
                                                  />
                                                </TooltipTrigger>
                                                <TooltipContent className='bg-black-500 max-w-[275px] border-0'>
                                                  <p className='text-white'>
                                                    Investments could take up to 4 days to reflect
                                                    in your account
                                                  </p>
                                                  <TooltipArrow />
                                                </TooltipContent>
                                              </Tooltip>
                                            </TooltipProvider>
                                          )}
                                        </>
                                      )}
                                    </div>
                                  }

                                  <div className='hidden md:flex justify-end items-center gap-x-1 min-w-[150px]'>
                                    {orders[0]?.basketStatus.toLowerCase() === 'completed' ? (
                                      <p className='font-semibold leading-6 text-black-500'>
                                        ₹ {toCurrency(getTotalAmountNew(sortedOrders))}
                                      </p>
                                    ) : (
                                      <>
                                        {orders[0]?.basketStatus.toLowerCase() != 'failed' && (
                                          <TooltipProvider delayDuration={0}>
                                            <Tooltip>
                                              <TooltipTrigger className='text-black-400'>
                                                In progress{' '}
                                                <Info fontSize='10px' className='text-black-100' />
                                              </TooltipTrigger>
                                              <TooltipContent className='bg-black-500 max-w-[275px] border-0'>
                                                <p className='text-white'>
                                                  Investments could take up to 4 days to reflect in
                                                  your account
                                                </p>
                                                <TooltipArrow />
                                              </TooltipContent>
                                            </Tooltip>
                                          </TooltipProvider>
                                        )}
                                      </>
                                    )}

                                    {expandedIndex === index ? (
                                      <KeyboardArrowUp
                                        className='flex-shrink-0 text-black-200'
                                        sx={{ fontSize: '24px' }}
                                      />
                                    ) : (
                                      <KeyboardArrowDown
                                        className='flex-shrink-0 text-black-200'
                                        sx={{ fontSize: '24px' }}
                                      />
                                    )}
                                  </div>
                                </div>
                              </div>
                              <AnimatedDisclosure
                                open={expandedIndex === index}
                                className='text-sm md:pl-6 flex-col justify-between items-start mt-4 border-b text-gray-500'
                                contentClassName='pt-4'
                              >
                                {Object.entries(sortedOrders)?.map(([date, orders]) => {
                                  // Check if all orders have the same order number

                                  const allSameOrderDateSame = orders.every(
                                    (order) => order.createdDate.split(' ')[0] === date,
                                  )

                                  return (
                                    <>
                                      {orders.map((order, orderIndex) => {
                                        // Show order number and date only once if all orders have same order number
                                        const shouldShowOrderInfo =
                                          !allSameOrderDateSame ||
                                          (allSameOrderDateSame && orderIndex === 0)

                                        return (
                                          <div
                                            className={`p-4 flex items-center lg:items-start w-full`}
                                            key={date + orderIndex}
                                          >
                                            <div className='flex justify-between w-full'>
                                              <div className='flex justify-between items-center w-full'>
                                                <div className='w-full md:w-auto'>
                                                  {shouldShowOrderInfo && (
                                                    <p className='text-black-400 text-sm mb-1'>
                                                      {date}
                                                    </p>
                                                  )}

                                                  <div className='flex justify-between items-start md:items-center gap-x-2'>
                                                    <img
                                                      src={`${env.MF_LOGOS_URL}/${order?.amcCode}.png`}
                                                      className='h-12 w-12 rounded-[8px] mt-1'
                                                    />
                                                    <div className='w-full md:w-auto'>
                                                      <p className='font-semibold text-gray-900  md:max-w-full text-wrap leading-6'>
                                                        {order?.legalName
                                                          ? order?.legalName
                                                          : order?.schemeName}
                                                      </p>

                                                      <div className='flex justify-between md:justify-normal w-full gap-x-5'>
                                                        <p
                                                          className={`text-sm font-medium ${
                                                            getStatus(order.currentStatus) ===
                                                            'Failed'
                                                              ? 'text-error-600'
                                                              : getStatus(order.currentStatus) ===
                                                                'Allotted'
                                                              ? 'text-secondary-600'
                                                              : getStatus(order.currentStatus) ===
                                                                'Redemption Done'
                                                              ? 'text-secondary-600'
                                                              : 'text-warning-600'
                                                          }`}
                                                        >
                                                          {getStatus(order.currentStatus)}
                                                        </p>

                                                        <p className='hidden md:block text-sm text-black-400 leading-5 font-medium'>
                                                          Order ID : {order?.orderNumber}
                                                        </p>

                                                        {order?.buySell && (
                                                          <p
                                                            className={`md:hidden text-sm leading-4 px-3 py-1 rounded-full ${
                                                              order?.buySell === 'P'
                                                                ? 'bg-secondary-50 text-secondary-600'
                                                                : 'bg-error-50 text-error-600'
                                                            }`}
                                                          >
                                                            {order?.buySell === 'P'
                                                              ? 'Buy'
                                                              : 'Sell'}
                                                          </p>
                                                        )}
                                                      </div>

                                                      <div className='flex md:hidden justify-between items-center gap-x-2'>
                                                        {order.allotedUnits && (
                                                          <p className='text-sm font-medium text-black-400'>
                                                            {order.allotedUnits
                                                              ? toCurrency(order.allotedUnits)
                                                              : null}{' '}
                                                            Units
                                                          </p>
                                                        )}

                                                        {order.allotedAmt && (
                                                          <p className='font-semibold leading-6 text-black-500'>
                                                            ₹{' '}
                                                            {order.allotedAmt
                                                              ? toCurrency(order.allotedAmt)
                                                              : null}
                                                          </p>
                                                        )}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className='flex items-center gap-x-2'>
                                                  <div className='hidden md:flex justify-center leading-5 flex-shrink-0 text-right min-w-[100px] pr-2'>
                                                    {order.allotedUnits && (
                                                      <p className='text-sm font-medium text-black-400'>
                                                        {order.allotedUnits
                                                          ? toCurrency(order.allotedUnits)
                                                          : null}{' '}
                                                        Units
                                                      </p>
                                                    )}
                                                  </div>

                                                  <div className='hidden md:flex justify-end items-center gap-x-1 min-w-[150px] pr-4'>
                                                    {order.allotedAmt && (
                                                      <p className='font-semibold leading-6 text-black-500'>
                                                        ₹{' '}
                                                        {order.allotedAmt
                                                          ? toCurrency(order.allotedAmt)
                                                          : null}
                                                      </p>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )
                                      })}
                                    </>
                                  )
                                })}
                              </AnimatedDisclosure>
                            </div>
                          </div>
                        )
                      })
                    ) : (
                      <SIPsEmpty
                        title='You haven’t started any new orders yet.'
                        description='It seems like you haven’t started any new orders yet. Once you place an order, it will appear here as it progresses through the system.'
                        mainText='You haven’t started any new orders yet.'
                        page='/dashboard/mutual-funds/orders'
                        showButton={false}
                        variant='failed'
                      />
                    )}
                  </div>
                </>
              )}
            </TabsContent>

            {/* <TabsContent value='Basket'>b</TabsContent> */}
          </Tabs>

          <div className='min-h-[calc(100svh-180px)] bg-white pt-2 pb-28 lg:pb-8'>
            {orders?.state === 'hasValue' &&
              (orders?.contents?.length === 0 || orders?.contents?.orders?.length === 0) && (
                <SIPsEmpty
                  title='You haven’t placed any orders yet'
                  description='Once you place a mutual fund or basket order, its status will appear here.'
                  mainText='You haven’t placed any orders yet'
                  page='/dashboard/plans'
                  showButton={false}
                  variant='orders'
                />
              )}

            {orders?.contents?.status === 'FAILURE' && (
              <div className='flex items-center justify-center px-4 py-8'>
                <ApiErrorState />
              </div>
            )}
          </div>
        </>
      )

    case 'hasError':
      return (
        <div className='bg-white flex items-center justify-center'>
          <ApiErrorState />
        </div>
      )

    default:
      return null
  }
}

export default MFBasketsOrders
